import PartnerMobileCard from './PartnerMobileCard';

const PartnerMobileList = ({ partners, onView, onEdit, onFreeze, onDelete }) => {
  return (
    <div className="md:hidden divide-y divide-slate-100">
      {partners.map((partner) => (
        <PartnerMobileCard
          key={partner._id}
          partner={partner}
          onView={onView}
          onEdit={onEdit}
          onFreeze={onFreeze}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default PartnerMobileList;
